// clipboard.js
function copyURL() {
    navigator.clipboard.writeText(window.location.href)
        .then(() => {
          //  alert('URL wurde kopiert: ' + window.location.href);
            console.log('URL wurde kopiert: ' + window.location.href);
        })
        .catch(err => {
            console.error('Fehler beim Kopieren der URL:', err);
        });
}

document.addEventListener('DOMContentLoaded', () => {
    const copyElement = document.querySelector('div.copyURL'); // Achte auf die korrekte Klasse und das Element
    if (copyElement) {
        copyElement.addEventListener('click', copyURL);
    }
});

export { copyURL };

